import React, {useState} from "react";
import ReactCardFlip from "react-card-flip";
import he from "he";
import uploadImage from "../../../assets/images/icons/benefits/uploadImageBenefits.svg"

const BenefitsCard = ({benefit, isDisabled, backgroundColor}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const decodedDescription = he.decode(benefit.description || "Especificación");
  const textColor = isDisabled ? "text-[#52526C]" : "text-white";

  return (
    <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
    <button
    style={{ backgroundColor: isDisabled ? "#B9B9B9" : benefit.color }}
    onClick={() => setIsFlipped(true)}
     className={`p-2 gap-1 w-[135px] h-[167px] rounded-lg flex flex-col ${isDisabled ? '' : ''}`}
      >
      <img 
       src={benefit.image ? benefit.image : uploadImage}
       alt={benefit.title || "Imagen"}
       className={`object-fill w-[123px] h-[97px] rounded-[4.48px] ${isDisabled ? 'grayscale' : ''}`}
        />
      <p className={`text-[11px] leading-[10.4px]  text-left font-itcmedium break-words whitespace-normal ${textColor}`}>
        {benefit.title}
      </p>
      {benefit.exclusive && (
      <p className={`text-[8px] tracking-wider text-white text-left font-itcbold `}>
        EXCLUSIVO
      </p>
      )}
    </button>

    <button
      style={{ backgroundColor: isDisabled ? "#B9B9B9" : benefit.color }}
      className={`w-[135px] h-[167px] p-2 rounded-lg flex items-start justify-start overflow-hidden
      ${isDisabled ? '' : ''}`}
      onClick={() => setIsFlipped(false)}
    >
        <style>
        {`
          .link a {
            color: #3b82f6 !important; 
            text-decoration: underline !important; 
          }
        `}
        </style>
        <div
          style={{ 
            color: 'white',
            hyphens: 'auto',
            WebkitHyphens: 'auto',
            msHyphens: 'auto'
          }}
          dangerouslySetInnerHTML={{ __html: decodedDescription }}
          className="text-[11px] leading-[12px] link font-itcmedium text-white break-words whitespace-normal overflow-hidden"
        />
      </button>
    </ReactCardFlip>
  );
};

export default BenefitsCard;